import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { CREATE_NEW_ROLE, DELETE_ROLE, DUPLICATE_ROLE, GET_ROLES, MODIFY_ROLE } from "./actionTypes"
import {
  newRoleSuccess,
  newRoleError,
  getRolesSuccess,
  getRolesError,
  deleteRoleError,
  modifyRoleSuccess,
  modifyRoleError,
} from "./actions"

import { postCreateRole, putModifyRole, getRoles, deleteRole, genericPostRequest } from "../../helpers/sf_backend_helper"

import { AppConfiguration } from "config"

function* createRole({ payload: { role, history } }) {
  try {
    if (AppConfiguration.DEFAULT_AUTH === "jwt") {
      let user_auth = localStorage.getItem("authUser")

      const response = yield call(
        postCreateRole,
        `${AppConfiguration.BACKEND_URL}/api/v1/roles`,
        {
          role: role,
          token: JSON.parse(user_auth).user.token,
          account_id: JSON.parse(user_auth).user.account_id,
        }
      )
      yield put(newRoleSuccess(response))
    } else if (AppConfiguration.DEFAULT_AUTH === "fake") {
    }
    history.push("/roles")
  } catch (error) {
    yield put(newRoleError(error))
    history.push("/roles")
  }
}

function* modifyRole({ payload: { role, history } }) {
  try {
    if (AppConfiguration.DEFAULT_AUTH === "jwt") {
      let user_auth = localStorage.getItem("authUser")

      const response = yield call(
        putModifyRole,
        `${AppConfiguration.BACKEND_URL}/api/v1/roles/${role.id}`,
        {
          role: {
            name: role.name,
            permissions: role.permissions,
          },
          token: JSON.parse(user_auth).user.token,
          account_id: JSON.parse(user_auth).user.account_id,
        }
      )
      yield put(modifyRoleSuccess(response))
    } else if (AppConfiguration.DEFAULT_AUTH === "fake") {
    }
    history.push("/roles")
  } catch (error) {
    yield put(modifyRoleError(error))
    history.push("/roles")
  }
}

function* fetchRoles(action) {
  try {
    if (AppConfiguration.DEFAULT_AUTH === "jwt") {
      let user_auth = localStorage.getItem("authUser")
      const response = yield call(
        getRoles,
        `${AppConfiguration.BACKEND_URL}/api/v1/roles`,
        {
          token: JSON.parse(user_auth).user.token,
          account_id: JSON.parse(user_auth).user.account_id,
        }
      )
      yield put(getRolesSuccess(response))
    } else if (AppConfiguration.DEFAULT_AUTH === "fake") {
    }
    //history.push("/roles")
  } catch (error) {
    yield put(getRolesError(error))
  }
}

function* onDeleteRole({ payload: { role, replacement_role_id } }) {
  try {
    let user_auth = localStorage.getItem("authUser")
    let response = yield call(
      deleteRole,
      `${AppConfiguration.BACKEND_URL}/api/v1/roles/${role.id}`,
      {
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id,
        replacement_role_id: replacement_role_id
      }
    )

    // XXX: Call get all roles again since we've mutated the state
    // of other roles by adjusting memberships (for replacing roles)
    response = yield call(
      getRoles,
      `${AppConfiguration.BACKEND_URL}/api/v1/roles`,
      {
        token: JSON.parse(user_auth).user.token,
        account_id: JSON.parse(user_auth).user.account_id
      }
    )
    yield put(getRolesSuccess(response))
  } catch (error) {
    yield put(deleteRoleError(error))
  }
}

function* onDuplicateRole(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/duplicate_roles`,
      {
        body: JSON.stringify({
          role_id: action.payload.id
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(newRoleSuccess({ data: response }))
  } catch (error) {
    yield put(newRoleError(error))
  }
}

function* roleSaga() {
  yield takeEvery(CREATE_NEW_ROLE, createRole)
  yield takeEvery(MODIFY_ROLE, modifyRole)
  yield takeEvery(GET_ROLES, fetchRoles)
  yield takeEvery(DELETE_ROLE, onDeleteRole)
  yield takeEvery(DUPLICATE_ROLE, onDuplicateRole)
}

export default roleSaga
